import Vue from 'vue'

import 'normalize.css/normalize.css' // 样式初始化

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // element 英文包

import '@/styles/index.scss' // 全部样式文件

import App from './App'
import store from './store'
import router from './router'
import '@wangeditor/editor/dist/css/style.css' // 引入wangeditor 样式
import '@/icons' // svg图标
import '@/permission' // 权限控制 导航守卫
import '@/utils/tools' // 全局引入组件

import 'default-passive-events'

// 使用 ElementUI 英文版
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)

Vue.config.productionTip = false

// 接数据时打开
import showmessage from '@/utils/message'
Vue.prototype.$message = showmessage

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
